import styled, { css, keyframes } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { MODAL_ANIMATION_DURATION } from '@/styles/constants';

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

export const Box = styled.div<{
  $isOpen?: boolean;
  $background?: string;
  $isKeyboardOpen?: boolean;
}>`
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 14px 14px 0 0;
  overscroll-behavior: none;
  background-color: ${({ theme, $background }) =>
    $background || theme.palette.primary.background};
  z-index: 10200;
  padding-bottom: ${({ theme, $isKeyboardOpen }) =>
    theme.isWebView && !$isKeyboardOpen ? `${theme.insetsBottom}px` : 0};
  animation: ${({ $isOpen }) => ($isOpen ? slideIn : slideOut)}
    ${MODAL_ANIMATION_DURATION}ms ease-in-out forwards;

  body.ios &:focus-within {
    padding-bottom: 0;
  }
`;

export const Head = styled.div<{
  $headPaddingTop: number;
  $isTitleCentered: boolean;
  $hasBorder: boolean;
  $background?: string;
}>`
  position: relative;
  display: flex;
  justify-content: ${({ $isTitleCentered }) =>
    $isTitleCentered ? 'center' : 'flex-start'};
  align-items: center;
  width: 100%;
  height: 60px;
  padding: ${({ $headPaddingTop }) => $headPaddingTop}px 0 0 15px;
  gap: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme, $background }) =>
    $background || theme.palette.primary.background};

  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
    `}
`;

export const Title = styled(Typography.Header)`
  max-width: 85%;
`;

export const Close = styled(Button)`
  position: absolute;
  right: 0;
`;

export const Body = styled.div<{ $background?: string }>`
  padding: 0 15px;
  background-color: ${({ theme, $background }) =>
    $background || theme.palette.primary.background};

  body.ios ${Box}:focus-within & {
    margin-bottom: var(--ios-modal-keyboard-height, 0px);
  }
`;
